<template>

  <div class="title-style">
    <div>
      <div class="text">{{text}}</div>
      <div class="line"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'titleCom',
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data () {
    return {

    }
  }
}

</script>
<style  lang="scss" scoped>
.title-style {
  min-width: 100px;
  min-height: 40px;
  display: flex;
  .text {
    font-family: 'PingFangSC-Semibold', 'PingFang SC Semibold',
      'PingFang SC ExtraLight', 'PingFang SC', sans-serif;
    font-weight: 650;
    font-style: normal;
    font-size: 30px;
  }
  .line {
    border-width: 0px;

    width: 100%;
    height: 5px;
    background: inherit;
    background-color: #174993;
    border: none;
    border-radius: 0px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
}
</style>